// @ts-check
import { Trans } from '@lingui/macro';
import { useHistory } from 'react-router-dom';
import Footer, {
  BackButton,
  CancelButton,
  NextButton,
} from '../../../../components/Layout/Footer';
import Layout from '../../../../components/Layout/Layout';
import Main from '../../../../components/Layout/Main';
import {
  PageHeader,
  PageSubtitle,
  PageTitle,
} from '../../../../components/Layout/PageHeader';
import ValidateImport, {
  useValidation,
} from '../../../../components/Validation/Validation';
import { ProgressIndicator, fieldsToImport, useLink } from './_config';

export default function Validation({ match }) {
  const link = useLink('validation');
  const { workspaceId, importId } = match.params;
  const props = useValidation({ workspaceId, importId });
  const history = useHistory();

  return (
    <Layout>
      <ProgressIndicator step="mapData" />
      <PageHeader>
        <PageTitle>
          <Trans>Data Validation</Trans>
        </PageTitle>
        <PageSubtitle>
          <Trans>Ensure your data is valid and ready to import.</Trans>
        </PageSubtitle>
      </PageHeader>

      <Main>
        <ValidateImport {...props} masterListColumns={fieldsToImport} />
      </Main>

      <Footer>
        <BackButton to={link.back()} />
        <CancelButton to={link.cancel()} />
        <NextButton
          disabled={!props?.isValid}
          onClick={() => history.push(link.next())}
        >
          <Trans>Next</Trans>
        </NextButton>
      </Footer>
    </Layout>
  );
}
